module.exports = __webpack_public_path__ + "assets/img/kv-548e5f3e.jpg";